import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import AlarmLevel from '@blade-sxp/task-management/components/alarm-level.vue';
import FrequencyAndThreshold from '@blade-sxp/task-management/components/frequency-threshold.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import { postTask, updateTask, getTaskDetail } from '@blade-sxp/task-management/api/creat-task/index';
import { isEmpty, cloneDeep, chunk } from 'lodash';
import TrafficType from '@blade-sxp/task-management/components/traffic-type/index.vue';
import { TrafficTypeModule } from '@blade-sxp/task-management/store/traffic-type';
import SingleConfidence from '@blade-sxp/task-management/components/single-confidence.vue';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
const Service = {
    postTask,
    updateTask,
    getTaskDetail,
};
let TrafficRetrograde = class TrafficRetrograde extends Vue {
    loading = false;
    name = '';
    status = 'ENABLE';
    isDetail = false;
    taskType = '';
    isReady = false;
    type = 'add';
    id = '';
    isError = false;
    disableRight = false;
    titleList = {
        leftTitle: this.$t('taskType'),
        rightTitle: this.$t('confidence'),
    };
    level = 'CRITICAL';
    alertInterval = 600;
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    dayOfWeeks = [];
    trafficReverseThreshold = {};
    effectiveTimes = [{ start: '', end: '' }];
    deviceIdList = [];
    allCompleted = false;
    confidenceValue = '66';
    remark = '';
    get isOVer() {
        return TrafficTypeModule.allCompleted;
    }
    get formData() {
        const { name, confidenceValue, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, alertInterval, allCompleted, level } = this;
        return {
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            alertInterval,
            allCompleted,
            level,
            confidenceValue,
        };
    }
    onchangeIsOVer(val) {
        this.allCompleted = val;
    }
    async validForm(val) {
        if (this.isDetail) {
            return;
        }
        if (!this.allCompleted) {
            this.disableRight = true;
            return;
        }
        for (let i = 1; i <= 5; i++) {
            if (this.$refs['ruleForm' + i]) {
                let res = await this.$refs['ruleForm' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        this.disableRight = false;
    }
    init() {
        const { type, id, taskType } = this.$route.query;
        this.type = type;
        this.taskType = taskType;
        this.id = id;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    beforeDestroy() {
        TrafficTypeModule.retrogradeMapData.clear();
        TrafficTypeModule.updataAllCompleted(false);
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const countUnitEnum = 'PERCENT';
        this.trafficReverseThreshold = {
            trafficReverseConfidence: {
                countUnitEnum: countUnitEnum,
                value: this.confidenceValue,
            },
        };
        const params = {
            taskName: this.name,
            taskStatus: taskStatus,
            taskType: this.taskType,
            remark: this.remark,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    enabledAlarmLevels: [this.level],
                    frequency: {
                        unit: 'SECOND',
                        value: this.alertInterval,
                    },
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : effectiveTimes,
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        trafficReverseThreshold: this.trafficReverseThreshold,
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            Service.postTask(params).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            Service.updateTask({ taskId: this.id, ...params }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    fromDataDeviceConfig() {
        const config = [];
        const retrogData = TrafficTypeModule.retrogradeMapData;
        let requestMap = new Map();
        requestMap = cloneDeep(retrogData);
        if (!isEmpty(requestMap)) {
            requestMap?.forEach((item, key) => {
                const chunkData = chunk(item, 2);
                let directionRoiMappings = [];
                if (!isEmpty(chunkData)) {
                    const currentChunk = cloneDeep(chunkData);
                    currentChunk.forEach((it) => {
                        if (!isEmpty(it)) {
                            let itemRoiMapimgs = {
                                rawRoi: {
                                    id: 0,
                                    name: '',
                                    vertices: [],
                                },
                                directions: [],
                            };
                            it?.forEach((el) => {
                                if (el.type === 'polygon') {
                                    const { id, vertices } = el;
                                    vertices.shift();
                                    itemRoiMapimgs.rawRoi = {
                                        id: this.taskId(),
                                        name: id,
                                        vertices: vertices,
                                    };
                                }
                                if (el.type === 'arrow') {
                                    const { vertices } = el;
                                    itemRoiMapimgs.directions = vertices;
                                }
                            });
                            directionRoiMappings.push(itemRoiMapimgs);
                        }
                    });
                }
                const data = {
                    trafficReverseConfig: {
                        directionRoiMappings: directionRoiMappings,
                    },
                    deviceId: key,
                    incidentType: 'INCIDENT_TRAFFIC_RETROGRADE_DETECTION',
                    roiData: JSON.stringify({
                        id: key,
                        roi: item,
                    }),
                };
                config.push(data);
            });
        }
        return config;
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    getData() {
        this.loading = true;
        Service.getTaskDetail(Number(this.id))
            .then(({ name, status, remark, alarmConfig: { thresholdConfigs, notifyConfig }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes, trafficReverseThreshold } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
                this.alertInterval = notifyConfig?.frequency?.value;
                this.level = notifyConfig?.enabledAlarmLevels[0];
                this.confidenceValue = trafficReverseThreshold['trafficReverseConfidence'].value;
            }
            if (!isEmpty(deviceTaskConfigs)) {
                let deviceId = [];
                deviceTaskConfigs.forEach((item) => {
                    deviceId.push(item?.deviceId);
                    const roiData = JSON.parse(item?.roiData);
                    TrafficTypeModule.retrogradeMapData.set(roiData?.id, roiData?.roi);
                });
                this.deviceIdList = deviceId;
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                type: 'warning',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
};
__decorate([
    Watch('isOVer', { immediate: true })
], TrafficRetrograde.prototype, "onchangeIsOVer", null);
__decorate([
    Watch('formData', { deep: true, immediate: true })
], TrafficRetrograde.prototype, "validForm", null);
__decorate([
    Watch('$route', { immediate: true, deep: true })
], TrafficRetrograde.prototype, "init", null);
TrafficRetrograde = __decorate([
    Component({
        name: 'TrafficRetrograde',
        components: {
            'name-and-status': NameAndStatus,
            'st-device-darwer': DeviceDarwer,
            'valid-time': ValidTime,
            'alarm-level': AlarmLevel,
            'frequency-and-threshold': FrequencyAndThreshold,
            'button-box': ButtonBox,
            'st-traffic-type': TrafficType,
            'st-single-confidence': SingleConfidence,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    trafficReverseConfidence: 'Counterflow Driving',
                    taskType: 'Type',
                    confidence: 'Confidence',
                    alert: 'Alert Notification',
                    cancelSubmitTip: 'Data will not be saved and exit. Are you sure to exit?',
                    tip: 'Tips',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                },
                zh: {
                    trafficReverseConfidence: '逆行',
                    taskType: '类型',
                    confidence: '置信度',
                    alert: '告警通知',
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                },
            },
        },
    })
], TrafficRetrograde);
export default TrafficRetrograde;
